import React from "react";

const TextInput = props => {

    return (
        <textarea className={"input " + props.className} onChange={e => props.set(e.target.value)} value={props.v} disabled={props.disabled}/>
    );
}

TextInput.defaultProps = {

    disabled: false

}

export default TextInput;